const makesReducer = (state = {}, action) => {
  switch (action.type) {
    case 'FETCH_MAKES_SUCCESS':
      return {
        ...state,
        makes: action.entities,
      }
    case 'FETCH_MODELS_SUCCESS':
      return {
        ...state,
        models: action.entities,
      }
    default:
      return state
  }
}

export default makesReducer
